import React from 'react';
import PublicPageShell from '../components/PublicPageShell';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import Modules from '../components/Modules';
import MonthlyPlans from '../components/MonthlyPlans';
import ContactCTA from '../components/ContactCTA';

const sections = {
  'how-it-works': HowItWorks,
  pricing: Pricing,
  modules: Modules,
  plans: MonthlyPlans,
  contact: ContactCTA,
};

const SectionPage = ({ section }) => {
  const Section = sections[section];

  return (
    <PublicPageShell mainClassName="pt-20">
      <Section headingLevel="h1" />
    </PublicPageShell>
  );
};

export default SectionPage;
